import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import store from "../store";

const initialState = {
    filters: {
        topics: ["ALL"],
        subtopics: [],
        countries: [],
        duration: "7",
        platforms: [],
        languages: [],
        dataRuleFilter: "All",
    },
    filterUpdated: 0,
    filterRefineFilter: {
        exclusion: "yes",
    },

    dataUsageList: [],
    dataUsageListLoading: false,
    dataUsageListError: null,
    createQueryList: [],
};

const getList = (data, createdQuery) => {
    let result = [];
    let obj = {
        subtopicName: "",
        topicName: "",
        booleanQuery: "",
        topicType: "",
        total: 0,
        subTopicEle: {},
    };

    data?.forEach((ele, ind) => {
        ele.subtopics.forEach((element) => {
            let subTopicResult = createdQuery.filter((val) => val.subtopic_id == element.subtopic_id);
            if (subTopicResult[0]) {
                obj = {
                    subtopicName: subTopicResult[0].subtopic_name,
                    topicName: subTopicResult[0].topic_name,
                    booleanQuery: subTopicResult[0].boolean,
                    topicType: subTopicResult[0].data_fetch_enabled ? "Pull" : "Display",
                    total: element.total,
                    subTopicEle: subTopicResult,
                };

                result.push(JSON.parse(JSON.stringify(obj)));
            }
        });
    });
    result.sort((a, b) => a.total - b.total);
    return result;
};
const dataUsageReducer = (state = initialState, action) => {
    switch (action.type) {
        case "APPLY_FILTER_DATAUSAGE": {
            //console.log("first0000000",action.payload)
            return {
                ...state,
                filters: action.payload.filters,
                filterRefineFilter: action.payload.filterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            };
        }

        case isFulfilled("GET_DATAUSAGE_LIST"):
            // console.log("dsffdsfdsffsfsdfdsfds", action.payload.result?.data, state.createQueryList);
            return {
                ...state,
                dataUsageList: getList(action.payload.result?.data, state.createQueryList),
                dataUsageListLoading: false,
                dataUsageListError: null,
            };
        case isPending("GET_DATAUSAGE_LIST"):
            return { ...state, dataUsageListLoading: true, dataUsageListError: null };
        case isRejected("GET_DATAUSAGE_LIST"):
            return { ...state, dataUsageList: null, dataUsageListLoading: false, dataUsageListError: action.payload };

        case isFulfilled("CREATED_QUERY_LIST"):
            return {
                ...state,
                createQueryList: action.payload.data.filters.topicsAndSubtopics.filter(
                    (account) => !["competitor", "opa"].includes(account?.config_source?.toLowerCase()),
                ),
            };

        case isFulfilled("GET_DATA_USAGE_FILTER"): {
            let filters = action.payload.data.config?.filter_config?.query || {};
            filters = Object.prototype.hasOwnProperty.call(filters, "topics") ? filters : state.filters;

            return {
                ...state,
                filters,
                filterRefineFilter: action.payload.data?.config?.filter_config?.refineFilter || state.filterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            };
        }
        default:
            return state;
    }
};

export default dataUsageReducer;
